<template>
  <div class="select-trace-card card-border">

    
    <div class="card-content">
      <div class="trace-row">
        <select 
          id="trace-select"
          :value="traceFile"
          @change="(e) => {
            if (e.target.value) {
              emit('switch-tab', 'profile');
              emit('open-trace', {
                taskId: taskId,
                trace: e.target.value,
              });
            }
          }"
          class="trace-select"
        >
          <option value="">-- Select a trace --</option>
          <option 
            v-for="trace in traceOptions"
            :key="trace"
            :value="trace"
          >
            {{ trace }}
          </option>
        </select>
        
        <button
          class="icon-btn"
          :disabled="!traceFile"
          @click="() => {
            if (traceFile) {
              emit('switch-tab', 'profile');
              emit('reload-trace', {
                taskId: taskId,
                trace: traceFile,
              });
            }
          }"
          title="Reload Trace"
        >
          <img src="@/assets/img/perf.svg" alt="Reload Trace" class="icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  taskId: {
    type: Number,
    default: null,
  },
  traceOptions: {
    type: Array,
    default: () => [],
  },
  traceFile: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['open-trace', 'switch-tab', 'reload-trace']);
</script>

<style lang="scss" scoped>
.select-trace-card {
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 100%;
  max-width: 400px;
  background: white;
}

.card-header {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  @include themify() {
    border-bottom-color: themed('border-color');
  }

  h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    @include themify() {
      color: themed('body-text-color');
    }
  }
}

.card-content {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.trace-row {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.trace-select {
  flex: 1;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  @include themify() {
    color: themed('body-text-color');
    border-color: themed('border-color');
    background: themed('input-background');
  }

  &:focus {
    outline: none;
    border-color: #2196f3;
  }
}

.icon-btn {
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @include themify() {
    border-color: themed('border-color');
  }

  &:hover:not(:disabled) {
    background: #f0f0f0;
    @include themify() {
      background: themed('hover-background');
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: transparent;
  }

  .icon {
    width: 22px;
    height: 22px;
    display: block;
    fill: darkblue;
  }
}

.trace-icon {
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:not([disabled]) {
    &:hover {
      opacity: 0.8;
    }
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
